module.exports = __webpack_public_path__ + "img/icons/new/square-corner-66f80f28fea663412130eb107d82e92e.svg";